/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import cookie from "react-cookies";
import Select from "react-select";
import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, clientID, CompanyID, showAlert, showLoader, hideLoader } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "broadcast";
var moduleName = "Broadcast Customer Whatsapp Message";
var modulePath = "/clientpanel/broadcast";
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    const viewID = this.props.params?.ViewID || '';
    
    this.state = {
      companyID: companyID,
      viewID: viewID,
      path: this.props?.location?.pathname || "",
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      searchvalue: "",
      status: "",
      whatsappstatus: "",
      errorFile: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID) {
    var params = { deleteID: deleteID, company_id: this.state.companyID };
    var delurl = module + "delete";
    removeItem(params, delurl, "client");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "&broadcastId="+this.state.viewID;
    if (this.state.searchvalue !== "") {
      addParams += "&searchvalue=" + this.state.searchvalue;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }

    if (
      this.state.whatsappstatus !== null &&
      Object.keys(this.state.whatsappstatus).length > 0
    ) {
      addParams += "&whatsappstatus=" + this.state.whatsappstatus.value;
    }
    

    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        addParams,
      url: apiUrl + module + '/customer',
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        searchvalue: "",
        status: "",
        whatsappstatus: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  importCustomer() {
    $("#customermodal").modal("toggle");
  }

  confirmimportCustomer() {
    var formData = new FormData();
    var imagefile = document.querySelector("#cusatomer_file");
    if (imagefile.files.length === 0) {
      this.setState({ errorFile: true });
      return false;
    } else {
      this.setState({ errorFile: false });
    }

    showLoader("import_cust");
    formData.append("cusatomer_file", imagefile.files[0]);
    formData.append("company_admin_id", clientID());
    formData.append("company_id", CompanyID());
    axios
      .post(apiUrl + module + "import", formData, {
        headers: {
          Authorization: cookie.load("clientAccessToken"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        $("#customermodal").modal("toggle");
        hideLoader("import_cust");
        $("#cusatomer_file").val("");
        var errMsg =
          res.data.form_error !== "" ? res.data.form_error : res.data.message;
        if (res.data.status === "success") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      });
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"broadcast"} />
          <div className="layout-page">
            <Topmenu />
            <a
              href={void 0}
              className="hidden"
              data-bs-toggle="modal"
              data-bs-target="#customermodal"
              id="openmodel"
            >
              Load
            </a>

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-9 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-3 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>                 
                </div>

                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="searchvalue"
                        onChange={this.handleChangeText}
                        value={this.state.searchvalue}
                      />
                      <label htmlFor="searchvalue">Search Keyword</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select"
                        isClearable={true}
                        options={[
                          { value: "Pending", label: "Pending" },
                          { value: "Sent", label: "Sent" },
                          { value: "Failed", label: "Failed" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select mb-4">
                      <Select
                        value={this.state.whatsappstatus}
                        onChange={this.handleSelectChange.bind(this, "whatsappstatus")}
                        placeholder="Select"
                        isClearable={true}
                        options={[
                          { value: "accepted", label: "Accepted" },
                          { value: "queued", label: "Queued" },
                          { value: "sent", label: "Sent" },
                          { value: "delivered", label: "Delivered" },
                          { value: "read", label: "Read" },
                        ]}
                      />
                      <label className="select-box-label">Whatsapp Status</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="p-1 mt-4">
                    <table className="table table_custpdng_size">
                      <thead>
                        <tr>
                          <th>Customer Name</th>
                          <th>Customer Phone</th>
                          <th>Message ID</th>
                          <th>Status</th>
                          <th>Whatsapp Status</th>
                          <th>SendON</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={5} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <strong>{item.customer?.customerName || ''}</strong>
                                </td>
                                <td>{item.customer?.customerPhone || ''}</td>
                                <td>{item?.whatsappMsgSendID || ''}</td>
                                <td>{item.sendStatus}</td>
                                <td>{item?.whatsappStatus || ''}</td>
                                <td>{item?.messageSendON || ''}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={5}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
